const beaconSource = "https://static.cloudflareinsights.com/beacon.min.js";

export function installCloudflareWebAnalytics(
  document: Document,
  token: string | undefined,
) {
  const normalizedToken = token?.trim() ?? "";
  if (!/^[A-Za-z0-9_-]{20,80}$/.test(normalizedToken)) return false;
  if (document.querySelector("script[data-cf-beacon]")) return true;

  const script = document.createElement("script");
  script.type = "module";
  script.src = beaconSource;
  script.defer = true;
  script.dataset.cfBeacon = JSON.stringify({
    token: normalizedToken,
    spa: false,
  });
  document.head.append(script);
  return true;
}
